import cn from "classnames"
import Image from "components/Image"
import richText from "utilities/richText"

export default function PageIntro({ blok, children }) {
  return (
    <section
      className={cn({
        "px-6": !blok.image?.filename,
        "sm:px-6": blok.image?.filename,
      })}
    >
      <div
        className={cn("mx-auto w-full max-w-screen-xl pb-12 pt-7 lg:pb-18", {
          "flex flex-col gap-6 lg:flex-row lg:gap-20": blok.variations === "vertical" || blok.image?.filename,
        })}
      >
        <div
          className={cn("flex flex-col gap-4 lg:basis-7/12", {
            "lg:flex-row lg:gap-10": blok.variations === "horizontal" && !blok.image?.filename,
            "px-6 sm:px-0": blok.image?.filename,
          })}
        >
          {children ? children : null}
          <h1
            className={cn("font-medium text-teal-dark", {
              "lg:basis-1/3": blok.variations === "horizontal" && !blok.image?.filename,
            })}
          >
            {blok.heading}
          </h1>
          <div
            className={cn("prose lg:max-w-3xl", {
              "lg:basis-2/3": blok.variations === "horizontal" && !blok.image?.filename,
            })}
          >
            {richText(blok.content)}
          </div>
        </div>
        {blok.image?.filename ? (
          <div className="lg:basis-5/12 lg:pt-6">
            <Image
              src={blok.image.filename}
              alt={blok.image.filename}
              placeholder={blok.image?.blurDataURL ? "blur" : "empty"}
              blurDataURL={blok.image?.blurDataURL}
              width={463}
              height={271}
              style={{ width: "100%", height: "auto" }}
              className="relative z-10 max-h-[360px] min-h-[275px] w-full rounded-10 object-cover"
            />
          </div>
        ) : null}
      </div>
    </section>
  )
}
